import { useAuthentication } from '@bestseller-bit/frontend-community.utilities.authentication';
import { useMemo } from 'react';

export const useHasDevTools = () => {
    const { account } = useAuthentication();
    const isAdmin = (account?.idTokenClaims?.roles ?? []).includes('admin');
    const hasDevTools = useMemo(() => isAdmin, [isAdmin]);

    return hasDevTools;
};
